export const API_ROOT = '/secure/patients_plugin/api';
export const PASSWORD_RESET_URL = '/secure/password_reset_form/';
export const API_PASSWORD_RESET_URL = `${API_ROOT}/password_reset/`;
export const API_RESEND_ACTIVATION_LINK = `${API_ROOT}/resend_activation_link/`;
export const RULES_PDF_URL = '/static/docs/regulamin_pacjent.pdf';

export const PATIENTS_PORTAL_LOGIN_URL = '/secure/login/patient/';

export const TIMEOUTS = {
    LOADER: 200,
    ALERT: 8 * 1000,
    DEBOUNCER: 350,
};

export const DATE_PICKER_CONFIG = {
    closeText: 'Zamknij',
    prevText: '&#x3c;Poprzedni',
    nextText: 'Następny&#x3e;',
    currentText: 'Dziś',
    monthNames: [
        'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec',
        'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
    ],
    monthNamesShort: ['Sty', 'Lu', 'Mar', 'Kw', 'Maj', 'Cze',
        'Lip', 'Sie', 'Wrz', 'Pa', 'Lis', 'Gru'
    ],
    dayNames: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    dayNamesShort: ['Nie', 'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'So'],
    dayNamesMin: ['N', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
    weekHeader: 'Tydz',
    dateFormat: 'yy-mm-dd',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: '',
    yearRange: '2017:2024',
};

export const NEW_VISIT_STEPS = {
    CITY: 'city',
    SPECIALTY: 'specialty',
    DEPARTMENTS: 'departments',
    DOCTOR: 'doctor',
    DATE: 'date',
    TIME: 'time',
    SEARCH: 'search',
};

export const TIME_PICKER_CONFIG = {
    STEP: 15,
};

export const FREE_TERM_TYPES = {
    NEW: 'NEW',
    CHOSEN: 'CHOSEN',
};

export const CHOOSE_CITY_PLACEHOLDER = 'Wybierz miasto';
export const CHOOSE_SPECIALTY_PLACEHOLDER = 'Wybierz specjalizację';
export const CHOOSE_DOCTOR_PLACEHOLDER = 'Wybierz lekarza';

export const NO_DOCTORS_PLACEHOLDER = 'Brak lekarzy';

export const ANY_SPECIALTY_PLACEHOLDER = 'Wszystkie';
export const ANY_DOCTOR_PLACEHOLDER = 'Dowolny';

export const PASSWORD_MIN_LENGTH = 8;

export const FIELD_ERRORS = {
    REQUIRED: 'To pole jest wymagane',
    TELEPHONE: 'Niepoprawny numer telefonu',
    EMAIL: 'Niepoprawny adres e-mail',
    PASSWORD_TOO_SHORT: `Hasło musi zawierać co najmniej ${PASSWORD_MIN_LENGTH} znaków`,
    PASSWORDS_DIFFER: 'Hasła nie są zgodne'
};

export const NO_PATIENT_VISITS = 3;

export const ALREADY_RESERVED_TERM_MSG = 'Chosen term is already reserved.';
export const TOO_MUCH_RESERVED_VISITS_MSG = `Patient is forbidden to have more than ${NO_PATIENT_VISITS} ` +
    'reserved visits created by himself.';



// WEBPACK FOOTER //
// ./src/constants.js